<div id="footerhide" class="footer-component no-print bg-[#F9FAFB] pt-10 pb-9 px-6  sm:px-0"
  *transloco="let t; currentLang as currentLang">
  <div class="block lg:max-w-6xl max-width-footer mx-auto">
    <div class="flex flex-col md:flex md:flex-row md:justify-between">
      <div class="xl:flex flex-col mb-6 xl:mb-0">
        <a href="https://bdjobs.com" target="_blank" rel="noopener noreferrer" class="max-w-fit">
          <img class="brand-logo !w-[148px] mb-8" ngSrc="images/bdjobsLogo.webp" width="148"
  height="40" draggable="false"
            fetchpriority="low" loading="lazy" />
        </a>
        <p class="text-[#101828] font-semibold text-xl gap-1">{{ t('footer.Need any support') }}?</p>
        <p class="text-[#182230] font-normal text-sm w-[280px]">{{ t('footer.Contact Center Title1') }}
          <span class="text-[#101828] font-semibold text-sm"><br>{{ t('footer.Contact Center Title2') }}</span>
        </p>
        <div class="flex gap-2 mt-3">
          <img [src]="environment.homeImageUrl + 'phone-call-01.svg'" alt="phone icon" loading="lazy" fetchpriority="low">
          <div class="text-[#D92D20] font-bold text-base">
            <p>16479</p>
            <p>09638666444</p>
            <p>01897627858</p>
          </div>
        </div>
      </div>
      <div class="  mb-2.5 md:mb-0 py-2.5 md:py-0 border-y border-[#E4E7EC] md:border-none">
        <div (click)="toggleSection('aboutUs')"
          class="flex items-center justify-between md:cursor-default cursor-pointer">
          <p class="text-base font-semibold mb-0 md:mb-2">{{ t('footer.about Us') }}</p>
          @if(openSection() !== 'aboutUs'){
          <img [src]="environment.homeImageUrl + 'icon-plus.svg'" alt="icon-plus" class="w-4 h-4 block md:hidden ">
          }@else {
            <img [src]="environment.homeImageUrl + 'minus.svg'" alt="icon-plus" class="w-4 h-4 block md:hidden ">
          }
        </div>
        <ul [class.block]="openSection() === 'aboutUs'" [class.hidden]="openSection() !== 'aboutUs' && isMobileDevice()"
          class="list-none pl-0  md:block">

            <li class="py-1">
              <a routerLink="/about-us" rel="noopener noreferrer"
                class="text-gray-700 hover:text-[#0E73A9] transition-all duration-300 text-sm font-medium">{{ t('footer.about Bdjobs.com') }}</a>
            </li>


          <li class="py-1">
            <a routerLink="/terms-condition"
             rel="noopener noreferrer"
              class="text-gray-700 hover:text-[#0E73A9] transition-all duration-300 text-sm font-medium">{{
              t('footer.Terms Conditions') }}</a>
          </li>
          <li class="py-1">
            <a routerLink="/policy"
            rel="noopener noreferrer"
              class="text-gray-700 hover:text-[#0E73A9] transition-all duration-300 text-sm font-medium">{{
              t('footer.Privacy Policy') }}</a>
          </li>
          <li class="py-1">
            <a routerLink="/feedback" target="_blank" rel="noopener noreferrer"
              class="text-gray-700 hover:text-[#0E73A9] transition-all duration-300 text-sm font-medium">{{
              t('footer.Feedback') }}</a>
          </li>
          <!-- <li class="py-1">
            <a href="https://bdjobs.com/feedback/?val=" target="_blank" rel="noopener noreferrer"
              class="text-gray-700 hover:text-[#0E73A9] transition-all duration-300 text-sm font-medium">{{
              t('footer.Feedback') }}</a>
          </li> -->
          <!-- <li class="py-1">
            <a
              href="{{ t('footer.Contact Us Url') }}"
              target="_blank"
              rel="noopener noreferrer"
              class="text-gray-700 hover:text-[#0E73A9] transition-all duration-300 text-sm font-medium"
              >{{ t('footer.Contact Us') }}</a
            >
          </li> -->

  <li class="py-1">
    <a routerLink="/contact-info" rel="noopener noreferrer"
      class="text-gray-700 hover:text-[#0E73A9] transition-all duration-300 text-sm font-medium">{{ t('footer.Contact Us') }}</a>
  </li>

          <li class="py-1">
            <a routerLink="/Accessibility-Statement"
              rel="noopener noreferrer"
              class="text-gray-700 hover:text-[#0E73A9] transition-all duration-300 text-sm font-medium">{{
              t('footer.Accessibility Statement') }}</a>
          </li>

        </ul>
      </div>
      <!-- Author: Chowdhury Mohammad Irfanuddin -->
      <div class="  mb-2.5 md:mb-0 pb-2.5 border-b border-[#E4E7EC] md:border-none">
        <div (click)="toggleSection('jobSeekers')"
          class="flex items-center justify-between md:cursor-default cursor-pointer">
          <p class="text-base font-semibold mb-0 md:mb-2">{{ t('footer.Job Seekers') }}</p>
          @if(openSection() !== 'jobSeekers'){
          <img [src]="environment.homeImageUrl + 'icon-plus.svg'" alt="icon-plus" class="w-4 h-4 block md:hidden ">
          }@else {
          <img [src]="environment.homeImageUrl + 'minus.svg'" alt="icon-plus" class="w-4 h-4 block md:hidden ">
          }
        </div>
        <ul [class.block]="openSection() === 'jobSeekers'"
          [class.hidden]="openSection() !== 'jobSeekers' && isMobileDevice()" class="list-none pl-0  md:block">
          <li class="py-1">
            <a [href]="pricingPageUrl" target="_blank"
              rel="noopener noreferrer"
              class="text-gray-700 hover:text-[#0E73A9] transition-all duration-300 text-sm font-medium">{{
              t('footer.bdJobs pro') }}</a>
          </li>
          <li class="py-1">
            <a href="https://mybdjobs.bdjobs.com/jobseeker-panel/signin" target="_blank" rel="noopener noreferrer"
              class="text-gray-700 hover:text-[#0E73A9] transition-all duration-300 text-sm font-medium">{{ t('footer.My
              Bdjobs Panel')}}</a>
          </li>
          <li class="py-1">
            <a href="https://mybdjobs.bdjobs.com/emailnotification/view_all_feature.asp" target="_blank"
              rel="noopener noreferrer"
              class="text-gray-700 hover:text-[#0E73A9] transition-all duration-300 text-sm font-medium">{{
              t('footer.List of Features')}}</a>
          </li>
          <li class="py-1">
            <a href="{{ t('footer.Video Guides Url')}}" target="_blank" rel="noopener noreferrer"
              class="text-gray-700 hover:text-[#0E73A9] transition-all duration-300 text-sm font-medium">{{
              t('footer.Video Guides')}}</a>
          </li>
          <li class="py-1">
            <a href="{{ t('footer.FAQ Url')}}" target="_blank" rel="noopener noreferrer"
              class="text-gray-700 hover:text-[#0E73A9] transition-all duration-300 text-sm font-medium">{{
              t('footer.FAQ')}}</a>
          </li>
        </ul>
      </div>
      <div class="  mb-2.5 md:mb-0 border-b pb-2.5 border-[#E4E7EC] md:border-none">
        <div (click)="toggleSection('recruiter')"
          class="flex items-center justify-between md:cursor-default cursor-pointer">
          <p class="text-base font-semibold mb-0 md:mb-2">{{ t('footer.Recruiter') }}</p>
          @if(openSection() !== 'recruiter'){
          <img [src]="environment.homeImageUrl + 'icon-plus.svg'" alt="icon-plus" class="w-4 h-4 block md:hidden ">
          }@else {
          <img [src]="environment.homeImageUrl + 'minus.svg'" alt="icon-plus" class="w-4 h-4 block md:hidden ">
          }
        </div>
        <ul [class.block]="openSection() === 'recruiter'"
          [class.hidden]="openSection() !== 'recruiter' && isMobileDevice()" class="list-none pl-0">
          <li class="py-1">
            <a href="https://recruiter.bdjobs.com/RecruiterAccount/register" target="_blank" rel="noopener noreferrer"
              class="text-gray-700 hover:text-[#0E73A9] transition-all duration-300 text-sm font-medium">{{
              t('footer.Create Account under Recruiter')}}</a>
          </li>
          <li class="py-1">
            <a href="https://recruiter.bdjobs.com/RecruiterAccount/service-packages" target="_blank" rel="noopener noreferrer"
              class="text-gray-700 hover:text-[#0E73A9] transition-all duration-300 text-sm font-medium">{{
              t('footer.Products/Service')}}</a>
          </li>
          <li class="py-1">
            <a href="https://recruiter.bdjobs.com/jobposting/" target="_blank" rel="noopener noreferrer"
              class="text-gray-700 hover:text-[#0E73A9] transition-all duration-300 text-sm font-medium">{{
              t('footer.Post a Job')}}</a>
          </li>
          <li class="py-1">
            <a href="https://recruiter.bdjobs.com/RecruiterAccount/faq" target="_blank" rel="noopener noreferrer"
              class="text-gray-700 hover:text-[#0E73A9] transition-all duration-300 text-sm font-medium">{{
              t('footer.FAQ under Recruiter')}}</a>
          </li>
        </ul>
      </div>
      <div class="  mb-6 md:mb-0">
        <div
          class="border border-[#F2F4F7] rounded-md px-3 py-3 shadow h-[112px]  bg-[rgba(255,255,255,0.4)] shadow-box">
          <p class="text-lg font-semibold mb-0.5">{{ t('footer.Download Mobile App')}}</p>
          <p class="text-[#344054] text-xs font-normal mb-4">{{ t('footer.Get real-time job updates on our app')}}</p>
          <div class="flex gap-2 mt-2">
            <a href="https://play.google.com/store/apps/details?id=com.bdjobs.app" target="_blank"
              rel="noopener noreferrer">
              <img [src]="environment.homeImageUrl + 'google-play-badge.svg'" alt="Download employer app" class="w-28 md:w-20" draggable="false"
                loading="lazy" fetchpriority="low" /></a>
            <a href="https://apps.apple.com/in/app/bdjobs/id1435728822" target="_blank" rel="noopener noreferrer">
              <img [src]="environment.homeImageUrl + 'App-Store-Badge.svg'" alt="Download employer iOS app" class="w-28 md:w-20"
                draggable="false" loading="lazy" fetchpriority="low" /></a>
            <a href="https://appgallery.huawei.com/#/app/C101426113" target="_blank" rel="noopener noreferrer">
              <img [src]="environment.homeImageUrl + 'Badges.svg'" alt="Download employer iOS app" class="w-28 md:w-20" draggable="false"
                loading="lazy" fetchpriority="low" /></a>
          </div>
        </div>
        <div class="border border-[#F2F4F7] rounded-md px-3 py-3 mt-2 shadow-box h-[112px] bg-[rgba(255,255,255,0.4)]">
          <p class="text-lg font-semibold mb-0.5">{{ t('footer.Download Employer App')}}</p>
          <p class="text-[#344054] text-xs font-normal mb-4">{{ t('footer.Post jobs and manage hiring anytime')}}</p>
          <div class="flex gap-2 mt-2">
            <a href="https://play.google.com/store/apps/details?id=com.bdjobs.recruiter" target="_blank"
              rel="noopener noreferrer">
              <img [src]="environment.homeImageUrl + 'google-play-badge.svg'" alt="Download employer app" class="w-28 md:w-20" draggable="false"
                loading="lazy" fetchpriority="low" /></a>
            <a href="https://apps.apple.com/us/app/bdjobs-employer/id1479828492" target="_blank"
              rel="noopener noreferrer">
              <img [src]="environment.homeImageUrl + 'App-Store-Badge.svg'" alt="Download employer iOS app" class="w-28 md:w-20"
                draggable="false" loading="lazy" fetchpriority="low" /></a>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-between md:pr-24 mt-5 pb-10 lg:pb-0">
      <div class="hidden md:block flex-1 max-w-fit">
        <h1 class="text-[#101828] font-semibold text-base">{{ t('footer.Our Valuable Partners')}}</h1>
        <div class="flex gap-4 mt-3">
          <a href="http://www.catho.com.br/" target="_blank"><img [src]="environment.homeImageUrl + 'catho-logo.png'" alt="Catho Logo"
              loading="lazy" fetchpriority="low"></a>
          <a href="https://www.workana.com/" target="_blank"><img [src]="environment.homeImageUrl + 'Logo_Workana.png'" alt="Workana Logo"
              loading="lazy" fetchpriority="low"></a>
          <a href="http://www.zhaopin.com/" target="_blank"><img [src]="environment.homeImageUrl + 'zhaopin_logo.ae6fe9.png'" alt="Zhaopin Logo"
              loading="lazy" fetchpriority="low"></a>
          
          <a href="http://www.seek.com.au/" target="_blank"><img [src]="environment.homeImageUrl + 'SEEK-Logo.png'" alt="Seek Logo"
              loading="lazy" fetchpriority="low"></a>
          <a href="https://www.occ.com.mx/" target="_blank"><img [src]="environment.homeImageUrl + 'Options_Clearing_Corporation_logo.png'"
              alt="OCC Logo" loading="lazy" fetchpriority="low"></a>
          <a href="https://www.jora.com/" target="_blank"><img [src]="environment.homeImageUrl + 'Jora.png'" alt="Jora Logo" loading="lazy"
              fetchpriority="low"></a>
          <a href="http://www.jobsdb.com/" target="_blank"><img [src]="environment.homeImageUrl + 'jobsdb-logo.png'" alt="JobsDB Logo"
              loading="lazy" fetchpriority="low"></a>
          <a href="http://www.jobberman.com/" target="_blank"><img [src]="environment.homeImageUrl + 'landscape.svg'" alt="Jobberman Logo"
              loading="lazy" fetchpriority="low"></a>
          <!-- <a href="http://www.brightermonday.com/" target="_blank"><img [src]="environment.homeImageUrl + 'catho-logo.svg'" alt="Brighter Monday Logo" loading="lazy" fetchpriority="low"></a> -->
          <!-- <a href="https://ajkerdeal.com/" target="_blank"><img [src]="environment.homeImageUrl + 'ajker-deal.svg'" alt="Ajker Deal Logo" loading="lazy" fetchpriority="low"></a> -->
        </div>
      </div>
      <div>
        <p class="text-[#101828] font-semibold text-base mb-2.5">{{ t('footer.Stay connected with us')}}</p>
        <div class="flex space-x-4 mb-4">
          <a href="https://www.instagram.com/mybdjobs/" target="_blank" rel="noopener noreferrer"
            class="group relative w-7 h-7 md:w-5 md:h-5">
            <img [src]="environment.homeImageUrl + 'instagram.svg'" alt="Youtube link"
              class="absolute inset-0 w-full h-full group-hover:opacity-0 transition-opacity duration-200"
              draggable="false" loading="lazy" fetchpriority="low" />
            <img ngSrc="images/instagram-color.png" width="20" height="20" alt="Youtube link hover"
              class="absolute inset-0 w-full h-full opacity-0 group-hover:opacity-100 transition-opacity duration-200"
              draggable="false" loading="lazy" fetchpriority="low" />
          </a>
          <a href="https://www.facebook.com/mybdjobs" target="_blank" rel="noopener noreferrer"
            class="group relative w-7 h-7 md:w-5 md:h-5">
            <img [src]="environment.homeImageUrl + 'facebook.svg'" alt="Youtube link"
              class="absolute inset-0 w-full h-full group-hover:opacity-0 transition-opacity duration-200"
              draggable="false" loading="lazy" fetchpriority="low" />
            <img [src]="environment.homeImageUrl + 'facebook-color.svg'" alt="Youtube link hover"
              class="absolute inset-0 w-full h-full opacity-0 group-hover:opacity-100 transition-opacity duration-200"
              draggable="false" loading="lazy" fetchpriority="low" />
          </a>
          <a href="https://www.linkedin.com/company/mybdjobs" target="_blank" rel="noopener noreferrer"
            class="group relative w-7 h-7 md:w-5 md:h-5">
            <img [src]="environment.homeImageUrl + 'linkedin.svg'" alt="Youtube link"
              class="absolute inset-0 w-full h-full group-hover:opacity-0 transition-opacity duration-200"
              draggable="false" loading="lazy" fetchpriority="low" />
            <img [src]="environment.homeImageUrl + 'linkedin-color-icon.svg'" alt="Youtube link hover"
              class="absolute inset-0 w-full h-full opacity-0 group-hover:opacity-100 transition-opacity duration-200"
              draggable="false" loading="lazy" fetchpriority="low" />
          </a>
          <a href="https://b.bdjobs.com/google-page" target="_blank" rel="noopener noreferrer"
            class="group relative w-7 h-7 md:w-5 md:h-5">
            <img [src]="environment.homeImageUrl + 'google.svg'" alt="Youtube link"
              class="absolute inset-0 w-full h-full group-hover:opacity-0 transition-opacity duration-200"
              draggable="false" loading="lazy" fetchpriority="low" />
            <img [src]="environment.homeImageUrl + 'google-color.svg'" alt="Youtube link hover"
              class="absolute inset-0 w-full h-full opacity-0 group-hover:opacity-100 transition-opacity duration-200"
              draggable="false" loading="lazy" fetchpriority="low" />
          </a>
          <a href="https://www.youtube.com/mybdjobs" target="_blank" rel="noopener noreferrer"
            class="group relative w-7 h-7 md:w-5 md:h-5">
            <img [src]="environment.homeImageUrl + 'youtube.svg'" alt="Youtube link"
              class="absolute inset-0 w-full h-full group-hover:opacity-0 transition-opacity duration-200"
              draggable="false" loading="lazy" fetchpriority="low" />
            <img [src]="environment.homeImageUrl + 'youtube-color.svg'" alt="Youtube link hover"
              class="absolute inset-0 w-full h-full opacity-0 group-hover:opacity-100 transition-opacity duration-200"
              draggable="false" loading="lazy" fetchpriority="low" />
          </a>

        </div>
      </div>
    </div>
  </div>
  <!-- <hr class="border-t border-[#E4E7EC] my-4" />
  <div class="flex justify-between container 2xl:mx-auto 2xl:max-w-[81rem] 2xl:px-0 xl:px-16">
    <p class="text-[#344054] text-sm font-medium">© Copyright bdjobs.com ltd. all right reserved.</p>
    <div class="hidden md:block pr-[70px]">
      <a class="text-[#344054] hover:text-[#0E73A9] text-sm font-medium mr-3" href="https://bdjobs.com/tos.asp">Terms of service</a>
      <a class="text-[#344054] hover:text-[#0E73A9] text-sm font-medium" href="https://bdjobs.com/policy/Privacy_policy.asp">{{ t('footer.Privacy Policy')}}</a>
    </div>
  </div> -->
</div>
